//Api
import * as api from 'api/docset'
import * as featureAPI from 'api/feature'

//Types
import { Format} from 'types/format'
import Docset from 'types/docset'

// Things we need on docset load
// 1. Docset Info
// 2. TOC
// 3. Languages for Docset
// 4. Alternative Docset Versions
// 5. Default Feature Flags
export function retrieveDocset(lang: string, alias: string, cfr: string, requestor: string | null): Promise<Docset> {
  return Promise.all([
    api.info(alias, cfr),
    api.toc(alias, cfr, requestor),
    api.languages(alias, cfr),
    api.versions(alias, cfr),
    featureAPI.featureFlags(alias, cfr, lang, requestor)
  ])
    .then(([
      info, 
      toc, 
      languages, 
      versions, 
      featureFlags
    ]) => {
      return {
        info,
        toc,
        languages,
        versions,
        featureFlags
      } as Docset
    })
}

export function retrieveUrl( source: any, alias: string, cfr: string, format: Format, lang: string): Promise<string> {
  return api.formatAvailable(source, alias, cfr, format, lang).then(result => result)
}

export const home = api.home